import React, { useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './css/style.css';
import Navbar from './Navbar';
import App from './App';
import Aboutus from './Aboutus';
import Services from './Services';
import WhyChooseUs from './WhyChooseUs';
import LatestFeatures from './LatestFeatures';
import PortfolioCompany from './PortfolioCompany';
import Contact from './Contact';
import Footer from './Footer';
import reportWebVitals from './reportWebVitals';
import WhyCritical from './WhyCritical';
import ScrollToTop from './ScrollToTop';
import Career from './Career';
import OurTeam from './OurTeam';
import ISOAIMSPage from './ISOAIMSPage';
import ScrollToTopButton from './ScrollToTopButton';

const root = ReactDOM.createRoot(document.getElementById('root'));

const AnimatedRoutes = () => {
  const location = useLocation();
  const nodeRefs = useRef({});

  if (!nodeRefs.current[location.pathname]) {
    nodeRefs.current[location.pathname] = React.createRef();
  }

  const noFooterPaths = ["/error"];

  return (
    <TransitionGroup>
      <CSSTransition
        key={location.key}
        timeout={1000}
        classNames="page"
        nodeRef={nodeRefs.current[location.pathname]}
      >
        <div ref={nodeRefs.current[location.pathname]} className="page">
          <ScrollToTop />
          <Routes location={location}>
            <Route path="/" element={<App />} />
            <Route path="/about" element={<Aboutus />} />
            <Route path="/services" element={<Services />} />
            <Route path="/whychooseus" element={<WhyChooseUs />} />
            <Route path="/latestfeatures" element={<LatestFeatures />} />
            <Route path="/ISOAIM" element={<ISOAIMSPage />} />
            <Route path="/portfoliocompany" element={<PortfolioCompany />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/critical" element={<WhyCritical />} />
            <Route path="/career" element={<Career />} />
            <Route path="/ourteam" element={<OurTeam />} />
          </Routes>
          <ScrollToTopButton />
          {!noFooterPaths.includes(location.pathname) && <Footer />}
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};

root.render(
  <BrowserRouter>
    <Navbar />
    <AnimatedRoutes />
  </BrowserRouter>
);

reportWebVitals();